// import axios from 'axios'

// const backendService = axios.create({
//     baseURL: process.env.VUE_APP_URL_API,
//     withCredentials: true,
//     headers: {
//         "Content-type": "multipath/form-data",
//         "Accept": "application/json",
//     }
// })

// //การใช้ Interceptor เพื่อแทรกตัว token เข้าไปใน header
// backendService.interceptors.request.use(config => {
//     let token = ''
//     try{
//         let userStorage = localStorage.getItem('cuciMember')
//         let userStorageJSON = JSON.parse(userStorage)
//         token = userStorageJSON['token']
//     }catch(error){
//         console.log(error)
//     }

//     if(token){
//         config.headers.Authorization = "Bearer "+token
//     }

//     return config

// })

// export default backendService

import axios from 'axios';

const authService = axios.create({
    baseURL: process.env.VUE_APP_URL_API,
    withCredentials: true,
    headers:{
        "Content-type": 'Application/json',
        "Accept": "application/json"
    }
})

// เพิ่ม Interceptor เพื่อแนบ XSRF-TOKEN จาก cookie ไปใน header
authService.interceptors.request.use(config => {
    // ดึงค่า XSRF-TOKEN จาก cookie
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const xsrfToken = getCookie('XSRF-TOKEN');
    if (xsrfToken) {
        config.headers['X-XSRF-TOKEN'] = xsrfToken;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default authService